"use client";

import { c as _c } from "react/compiler-runtime";
import { useCallback } from "react";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import type { TypedNotification } from "@/types/feed.types";
import type { ActiveDropState } from "@/types/dropInteractionTypes";
import { ActiveDropAction } from "@/types/dropInteractionTypes";
import type { DropInteractionParams } from "@/components/waves/drops/Drop";
import NotificationItems from "./NotificationItems";
import { useRouter } from "next/navigation";
import useDeviceInfo from "@/hooks/useDeviceInfo";
import { getWaveRoute } from "@/helpers/navigation.helpers";
type WaveWithChatScope = ExtendedDrop["wave"] & {
  chat?: {
    scope?: {
      group?: {
        is_direct_message?: boolean | undefined;
      } | undefined;
    } | undefined;
  } | undefined;
};
const hasChatScope = (wave: ExtendedDrop["wave"]): wave is WaveWithChatScope => typeof wave === "object" && wave !== null && "chat" in wave;
interface NotificationsWrapperProps {
  readonly items: TypedNotification[];
  readonly loadingOlder: boolean;
  readonly activeDrop: ActiveDropState | null;
  readonly setActiveDrop: (drop: ActiveDropState | null) => void;
}
export default function NotificationsWrapper(t0) {
  const $ = _c(18);
  const {
    items,
    loadingOlder,
    activeDrop,
    setActiveDrop
  } = t0;
  const router = useRouter();
  const {
    isApp
  } = useDeviceInfo();
  let t1;
  if ($[0] !== isApp || $[1] !== router) {
    t1 = drop => {
      if (!drop?.wave?.id) {
        return;
      }
      const isDirectMessage = hasChatScope(drop.wave) ? drop.wave.chat?.scope?.group?.is_direct_message ?? false : false;
      const href = getWaveRoute({
        waveId: drop.wave.id,
        serialNo: drop.serial_no,
        isDirectMessage,
        isApp
      });
      router.push(href);
    };
    $[0] = isApp;
    $[1] = router;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const onDropContentClick = t1;
  let t2;
  if ($[3] !== setActiveDrop) {
    t2 = param => {
      setActiveDrop({
        action: ActiveDropAction.REPLY,
        drop: param.drop,
        partId: param.partId
      });
    };
    $[3] = setActiveDrop;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const onReply = t2;
  let t3;
  if ($[5] !== setActiveDrop) {
    t3 = param_0 => {
      setActiveDrop({
        action: ActiveDropAction.QUOTE,
        drop: param_0.drop,
        partId: param_0.partId
      });
    };
    $[5] = setActiveDrop;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const onQuote = t3;
  let t4;
  if ($[7] !== loadingOlder) {
    t4 = loadingOlder && <div className="tw-flex tw-w-full tw-justify-center tw-py-3"><div className="tw-flex tw-items-center tw-gap-2 tw-text-xs tw-uppercase tw-tracking-wide tw-text-iron-400"><span className="tw-inline-flex tw-h-4 tw-w-4 tw-animate-spin tw-rounded-full tw-border-2 tw-border-iron-400 tw-border-t-transparent" /><span>Loading older notifications...</span></div></div>;
    $[7] = loadingOlder;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== activeDrop || $[10] !== items || $[11] !== onDropContentClick || $[12] !== onQuote || $[13] !== onReply) {
    t5 = <NotificationItems items={items} activeDrop={activeDrop} onReply={onReply} onQuote={onQuote} onDropContentClick={onDropContentClick} />;
    $[9] = activeDrop;
    $[10] = items;
    $[11] = onDropContentClick;
    $[12] = onQuote;
    $[13] = onReply;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== t4 || $[16] !== t5) {
    t6 = <div className="tw-relative tw-flex tw-flex-col tw-gap-3">{t4}{t5}</div>;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  return t6;
}